import React from 'react'
import { useTranslation, withTranslation, Trans } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';
import TimezoneSelect from 'react-timezone-select';
import momentTimezone from 'moment-timezone';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Badge } from 'react-bootstrap';
import Timezone from '../Timezone'
import Utility from '../Utility'

function UserProfileContent(props) {
    //===========random background color===========
    const hexToRgb = (hex) => {
        let bigint = parseInt(hex.slice(1), 16);
        let r = (bigint >> 16) & 255;
        let g = (bigint >> 8) & 255;
        let b = bigint & 255;
        return { r, g, b };
    }

    // Function to convert RGB to hex
    const rgbToHex = (r, g, b) => {
        return (
            "#" +
            ((1 << 24) + (r << 16) + (g << 8) + b)
                .toString(16)
                .slice(1)
                .toUpperCase()
        );
    }
    // Function to blend two colors
    const blendColors = (color1, color2) => {
        const rgb1 = hexToRgb(color1);
        const rgb2 = hexToRgb(color2);

        // Average the RGB values
        const r = Math.floor((rgb1.r + rgb2.r) / 2);
        const g = Math.floor((rgb1.g + rgb2.g) / 2);
        const b = Math.floor((rgb1.b + rgb2.b) / 2);

        return rgbToHex(r, g, b);
    }

    const getRandomLightColor = () => {
        const r = Math.floor(Math.random() * 156) + 100;
        const g = Math.floor(Math.random() * 156) + 100;
        const b = Math.floor(Math.random() * 156) + 100;
        return `rgb(${r}, ${g}, ${b})`;
    }

    const getRandomBackgroundColor = (user_name) => {
        const colors = {
            A: "#1abc9c",
            B: "#2ecc71",
            C: "#3498db",
            D: "#9b59b6",
            E: "#34495e",
            F: "#f1c40f",
            G: "#e67e22",
            H: "#e74c3c",
            I: "#95a5a6",
            J: "#16a085",
            K: "#27ae60",
            L: "#2980b9",
            M: "#8e44ad",
            N: "#2c3e50",
            O: "#f39c12",
            P: "#d35400",
            Q: "#c0392b",
            R: "#bdc3c7",
            S: "#7f8c8d",
            T: "#f39c12",
            U: "#d35400",
            V: "#c0392b",
            W: "#bdc3c7",
            X: "#7f8c8d",
            Y: "#16a085",
            Z: "#27ae60"
        };
        // console.log("user_name======",user_name)
        const nameParts = user_name?.split(" ").filter(Boolean).slice(0, 2);
        const initials = nameParts?.map(part => part.charAt(0).toUpperCase()).join("");
        const initialsLength = initials?.length;
        const firstLetter = nameParts[0]?.charAt(0).toUpperCase();
        let target_color = colors[firstLetter] || "#7f8c8d";
        if (initialsLength > 1) {
            const fl = initials?.split("")[0]
            const ll = initials?.split("")[1]
            const flc = colors[fl] || "#7f8c8d"
            const llc = colors[ll] || "#7f8c8d"
            target_color = blendColors(flc, llc);
        }
        // console.log("target_color======",target_color)
        return target_color;
    }

    const getRandomTextColor = () => {
        let whiteTextColor = '#FFFFFF';
        return whiteTextColor;
    }
    //end

    const { userCredentials, userProfileImage, userDetails, userFirstName, userLastName } = props;
    let userFullName = userFirstName + " " + userLastName;
    return (
        <>
            {userProfileImage != "" ?
                <li>
                    <div className='user_view_profile_sec_global'>
                        <div className="user_profile_name_icon">
                            <img className="user_icon" src={userProfileImage} />
                        </div>
                        <div className='name_phno_sec'>
                            <div className='name_sec'>
                                {userFullName.length >= 12 ?
                                    <OverlayTrigger overlay={<Tooltip>{userFullName}</Tooltip>} placement='bottom'>
                                        <span>{userFullName.substring(0, 9) + "..."}</span>
                                    </OverlayTrigger>
                                    :
                                    <span>{`${userFirstName} ${userLastName}`}</span>
                                }
                            </div>
                            <div className='phno_sec'>
                                {userDetails.user_email.length > 15 ? (
                                    <OverlayTrigger overlay={<Tooltip>{userDetails.user_email}</Tooltip>} placement='bottom'>
                                        <span>{userDetails.user_email.substring(0, 13) + "..."}</span>
                                    </OverlayTrigger>
                                ) : (
                                    <span>{userDetails.user_email}</span>
                                )}
                            </div>
                        </div>
                    </div>
                </li>
                :
                <li>
                    <div className='user_view_profile_sec_global'>
                        <div className="user_profile_name_icon" style={{
                            backgroundColor: getRandomBackgroundColor(`${userDetails && userLastName != undefined ? `${userFirstName} ${userLastName}` : userDetails && userLastName == undefined && `${userFirstName}`}`),
                            color: getRandomTextColor(),
                        }}>
                            {userDetails && userLastName != undefined ? `${userFirstName?.charAt(0)}${userLastName?.charAt(0)}` : userDetails && userLastName == undefined && `${userFirstName?.charAt(0)}`}
                        </div>
                        <div className='name_phno_sec'>
                            <div className='name_sec'>
                                {userFullName.length >=12 ?
                                    <OverlayTrigger overlay={<Tooltip>{userFullName}</Tooltip>} placement='bottom'>
                                        <span>{userFullName.substring(0, 9) + "..."}</span>
                                    </OverlayTrigger>
                                    :
                                    <span>{`${userFirstName} ${userLastName}`}</span>
                                }
                            </div>
                            <div className='phno_sec'>
                                {userDetails.user_email.length > 15 ? (
                                    <OverlayTrigger overlay={<Tooltip>{userDetails.user_email}</Tooltip>} placement='bottom'>
                                        <span>{userDetails.user_email.substring(0, 13) + "..."}</span>
                                    </OverlayTrigger>
                                ) : (
                                    <span>{userDetails.user_email}</span>
                                )}
                            </div>
                        </div>
                    </div>
                </li>
            }
        </>
    )
}
const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token,
        localTimeZoneName: globalState.mainReducerData.localTimeZone
    };
}

export default withRouter(connect(mapStateToProps, {})
    (withTranslation()(UserProfileContent)));
